import styled from 'styled-components';

import { ButtonContainer } from 'libs/ui';
import { WhiteStyledField } from 'libs/form';

export const TextareaStyledField = styled(WhiteStyledField)`
  height: 80px;
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding: 9px 0;
`;

export const StyledButtonContainer = styled(ButtonContainer)`
  margin-top: 20px;
  justify-content: flex-end;
`;

export const QrButton = styled.div`
  margin: 10px 0;
`;

export const WrapperToggle = styled.div`
  label {
    width: 200px;
  }
  input {
    margin: 0 4px;
    max-width: 37px;
  }
  span {
    margin: 0 4px;
  }
`;

export const InfoValue = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  .label {
    width: 200px;
    margin: 0 10px 0 0;
    font-size: 16px;
    line-height: 1;
    /* color: #3e3e3e; */
  }
  .value {
    /* color: #000; */
    opacity: 1;
    padding-left: 4px;
  }
`;
